import {
  Box,
  Button,
  Flex,
  FormControl,
  FormHelperText,
  Image,
  Input,
  InputGroup,
  Link,
  Stack,
  Text,
} from "@chakra-ui/react";
import React, { useState } from "react";
import { Context } from "../ContextWrapper";
import { createForgotPassword } from "../api/authentication";

export const ForgotPassword = () => {
  const context = React.useContext(Context);
  const [email, setEmail] = useState("");
  const [disabled, setDisabled] = useState(false);

  const submit = async (e) => {
    e.preventDefault();

    createForgotPassword({ email: email })
      .then((response) => {
        setDisabled(true);
        if (response.data.error) {
          context.fireToast(
            "Reset password",
            response.data.error,
            "error"
          );
        } else {
          context.fireToast(
            "Reset password",
            "Password change email sent.",
            "success"
          );
        }
      })
      .catch((err) => {
        if (err.status === 429) {
          context.fireToast(
            "Reset password",
            "Too many attempts. Please try again in an hour.",
            "error"
          );
        }
      });
  };

  return (
    <Flex
      flexDirection="column"
      width="100wh"
      height="100vh"
      backgroundColor="#FFFFFF"
      justifyContent="center"
      alignItems="center"
      minHeight={"500px"}
    >
      <Stack
        flexDir="column"
        mb="2"
        justifyContent="center"
        alignItems="center"
      >
        <Box minW={"100%"}>
          <form onSubmit={submit}>
            <Stack
              spacing={4}
              p="1.75rem"
              width={"90vw"}
              maxW={"438px"}
              backgroundColor="#FFFFFF"
              boxShadow="0px 8px 16px 0px #00000026"
              borderRadius={"5px"}
              alignItems={"center"}
            >
              <Box
                w="100%"
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                mb={2}
              >
                <Text fontSize={"24px"} fontWeight={400}>
                  Welcome to
                </Text>
                <Image
                  width={"221px"}
                  src="lucro-logo-light.png"
                  alt="Dan Abramov"
                />
              </Box>
              <FormControl w={"80vw"} maxW={"374px"}>
                <Text
                  fontSize={"16px"}
                  fontWeight={400}
                  mb={4}
                  textAlign={"center"}
                >
                  Enter your email and we'll send you a link to reset your
                  password.
                </Text>
                <InputGroup>
                  <Input
                    type="text"
                    placeholder="Enter email address"
                    value={email}
                    required
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </InputGroup>
              </FormControl>

              <Button
                mt={4}
                borderRadius={"4px"}
                type="submit"
                variant="solid"
                _hover={{ bg: "#535DEC" }}
                backgroundColor={"#536DEC"}
                w={"80vw"}
                maxW={"374px"}
                isDisabled={disabled}
              >
                Submit
              </Button>
              <FormControl>
                <FormHelperText
                  fontSize={"16px"}
                  fontWeight={400}
                  color={"#234E94"}
                  textAlign="center"
                >
                  <Link href="/login">Back to login</Link>
                </FormHelperText>
              </FormControl>
            </Stack>
          </form>
        </Box>
      </Stack>
    </Flex>
  );
};
